/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business PJ Sandbox 白板 APIクライアント。/pj-sandbox/boards/* (共有状態の取得・保存・編集履歴) を呼び出し
 * @graph-connects /pj-sandbox/boards [calls] 白板の共有状態取得・保存 API
 * @graph-connects /pj-sandbox/boards/history [calls] 白板の編集履歴取得 API
 */
import type {
  PjSandboxBoardKey,
  PjSandboxDocumentKey,
  PjSandboxBoardResponse,
  PjSandboxHistoryResponse,
  PutPjSandboxBoardRequest,
} from '@cortex/domain-product-innovation-lab-types';
import { request } from './_request.js';

/**
 * PJ Sandbox 白板の共有状態と編集履歴を扱う API クライアント。
 * 契約（req/res の型）は `@cortex/domain-product-innovation-lab-types` を単一 SoT とし、
 * サーバー側の route schema と同じ定義を参照する。
 * @graph-connects none
 */
export const pjSandboxApi = {
  getBoard: (boardKey: PjSandboxDocumentKey): Promise<PjSandboxBoardResponse> => {
    return request<PjSandboxBoardResponse>(`/pj-sandbox/boards/${encodeURIComponent(boardKey)}`);
  },
  saveBoard: (
    boardKey: PjSandboxDocumentKey,
    body: PutPjSandboxBoardRequest,
  ): Promise<PjSandboxBoardResponse> => {
    return request<PjSandboxBoardResponse>(`/pj-sandbox/boards/${encodeURIComponent(boardKey)}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    });
  },
  getHistory: (
    boardKey: PjSandboxBoardKey,
    params: { limit?: number; before?: string } = {},
  ): Promise<PjSandboxHistoryResponse> => {
    const search = new URLSearchParams();
    if (params.limit !== undefined) search.set('limit', params.limit.toString());
    if (params.before !== undefined && params.before !== '') search.set('before', params.before);
    const query = search.size > 0 ? `?${search.toString()}` : '';
    return request<PjSandboxHistoryResponse>(
      `/pj-sandbox/boards/${encodeURIComponent(boardKey)}/history${query}`,
    );
  },
};
